/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulActionResponse as DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/CustomResponses/successful-action-response';
import { PayBillDto as DigiworkMaitreDPosDtoBillsPayBillDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Bills/pay-bill-dto';

export interface PayBill$Params {
  billId: string;
      body?: DigiworkMaitreDPosDtoBillsPayBillDto
}

export function payBill(http: HttpClient, rootUrl: string, params: PayBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
  const rb = new RequestBuilder(rootUrl, payBill.PATH, 'post');
  if (params) {
    rb.path('billId', params.billId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>;
    })
  );
}

payBill.PATH = '/api/orders/bills/{billId}/pay-bill';
